export let TrendlineAlgorithm; // Options referenced from https://www.chartjs.org/docs/latest/api/interfaces/LineControllerDatasetOptions.html

(function (TrendlineAlgorithm) {
  TrendlineAlgorithm["Linear"] = "linear";
  TrendlineAlgorithm["Polynomial"] = "polynomial";
  TrendlineAlgorithm["Exponential"] = "exponential";
  TrendlineAlgorithm["Logarithmic"] = "logarithmic";
  TrendlineAlgorithm["Power"] = "power";
})(TrendlineAlgorithm || (TrendlineAlgorithm = {}));